import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
const URL = 'https://lawfeedback.onrender.com';

export default io(URL, { autoConnect: false, transports: ['websocket'], upgrade: false });
